<template>
  <section class="authContainer bg-custom">
    <!-- <div class="overlay visible"></div> -->
    <div class="main-popup visible shadow-custom rounded-lg bg-white pb-5">
      <div class="popup-header text-center">
        <div class="content">Reset your Password</div>
        <router-link to="/" class="d-block">
          <img
            class="img-fluid"
            src="/assets/images/brand1.png"
            width="180px"
            id="brand-logo"
          />
        </router-link>
      </div>
      <div class="popup-content">
        <div
          v-if="alert.message"
          :key="Math.random()"
          :class="'rounded-0 mb-2 text-center alert ' + alert.type"
        >
          {{ alert.message }}
        </div>
        <div
          v-else
          class="notifier mb-2 position-relative text-center bg-light p-2"
        >
          Please enter your reistered email to continue.
        </div>
        <form action="#" class="px-4 pt-1">
          <div class="form-content pt-0 w-100">
            <div class="form-group">
              <input
                type="text"
                name="phone"
                placeholder="Enter your phone number"
                class="form-control"
                v-validate="'required|digits:11'"
                :class="{ 'is-invalid': submitted && errors.has('phone') }"
                v-model="credentials.username"
              />
              <div
                v-if="submitted && errors.has('phone')"
                class="small invalid-feedback"
              >
                {{ errors.first("phone") }}
              </div>
            </div>
            <div class="form-group">
              <input
                type="text"
                name="code"
                placeholder="Enter your code here"
                class="form-control"
                v-validate="'required|digits:6'"
                :class="{ 'is-invalid': submitted && errors.has('code') }"
                v-model="credentials.code"
              />
              <div
                v-if="submitted && errors.has('code')"
                class="small invalid-feedback"
              >
                {{ errors.first("code") }}
              </div>
            </div>
            <div class="form-group">
              <input
                type="password"
                name="password"
                class="form-control"
                :class="{ 'is-invalid': submitted && errors.has('password') }"
                v-validate="{ required: true, min: 6 }"
                v-model="credentials.password"
                placeholder="Enter your password"
                ref="password"
              />
              <div
                v-if="submitted && errors.has('password')"
                class="small invalid-feedback"
              >
                {{ errors.first("password") }}
              </div>
            </div>
            <div class="form-group">
              <input
                type="password"
                name="password_confirmation"
                placeholder="Confirm your Password"
                class="form-control"
                :class="{
                  'is-invalid': submitted && errors.has('password_confirmation')
                }"
                v-validate="'required|confirmed:password'"
                v-model="credentials.password_confirmation"
                data-vv-as="password"
              />
              <div
                v-if="submitted && errors.has('password_confirmation')"
                class="small invalid-feedback"
              >
                {{ errors.first("password_confirmation") }}
              </div>
            </div>

            <div class="form-group">
              <button
                class="btn btn-dark btn-sm btn-pill btn-block"
                type="submit"
                :disabled="status.resetting"
                @click="handleSubmit"
              >
                <span v-if="status.resetting" class="donutSpinner"></span>
                <span v-else>Reset Password</span>
              </button>
            </div>
          </div>
          <div class="text-center">
            Already a member?
            <router-link to="/login" class="primary_link"
              >Sign In to your Account</router-link
            >
          </div>
        </form>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "Forgotpassword",
  metaInfo: {
    title: "Quickleap",
    titleTemplate: "%s | Reset Password",
    htmlAttrs: {
      lang: "en",
      amp: true
    }
  },
  data() {
    return {
      credentials: {
        username: "",
        code: "",
        password: "",
        password_confirmation: ""
      },
      submitted: false
    };
  },
  created() {
    this.clearAlert();
  },
  computed: {
    ...mapState("account", ["status"]),
    ...mapState({
      alert: state => state.alert
    })
  },
  methods: {
    ...mapActions("account", ["resetpassword"]),
    ...mapActions({
      clearAlert: "alert/clear"
    }),

    handleSubmit(e) {
      e.preventDefault();

      this.submitted = true;
      this.$validator.validate().then(valid => {
        if (valid) {
          const { password_confirmation, ...data } = this.credentials;
          this.resetpassword(data);
        }
      });
    }
  }
};
</script>
